<template>
    <ul :class="{ collapsed: collapsed }">
        <li
            v-for="channel in row.channels"
            :key="channel.id"
            :title="`${channel.type}: ${channel.frequency}`"
        >
            {{ channel.frequency }}
            <span
                class="channel-type"
                :class="channel.type"
                >{{ channel.type }}</span
            >
        </li>

        <li
            v-if="total > 4"
            class="toggle-display-all"
        >
            <a
                href="#"
                @click.prevent="getAllItems()"
                >{{ toggleText }}</a
            >
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        col: {
            type: Object,
            default: () => {},
        },
        total: {
            type: Number,
            default: () => null,
        },
        row: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            collapsed: true,
        }
    },

    computed: {
        toggleText() {
            return this.collapsed ? `Show All (${this.total})` : 'Collapse'
        },
    },

    methods: {
        getAllItems() {
            if (this.collapsed && this.total !== this.items.length) {
                this.$emit('get-relation-items')
            }
            this.collapsed = !this.collapsed
        },
    },
}
</script>

<style scoped>
.channel-type.Control {
    color: #75bac4;
}

.channel-type.Data {
    color: #ffb571;
}

.collapsed li:nth-of-type(n + 5) {
    display: none;
}

.toggle-display-all {
    display: list-item !important;
}
</style>
